import React, { useContext, useRef } from "react";
import { FormContext } from "./FormContext";
import { TextField } from "@shopify/polaris";
import ReactTooltip from "react-tooltip";

interface Props extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  label?: string;
  polaris?: boolean;
  onChangePolaris?: any;
  dataTip?: string;
}

export function TextInput(props: Props) {
  const context = useContext(FormContext);
  const ref = useRef<HTMLInputElement>(null);

  const className: string = context.error && context.error.name === props.name ? "form-control flash" : "form-control";

  if (props.polaris) {
    return (
      <div>
        <TextField
          label={<label data-tip={props.dataTip}>{props.label}</label>}
          labelHidden={!props.label}
          autoComplete="off"
          value={String(props.value ? props.value : "")}
          onChange={(v) => props.onChangePolaris && props.onChangePolaris(v)}
          type={props.type ? (props.type as any) : "text"}
          error={context.error?.name === props.name && `${props.label} was required`}
        />
        <ReactTooltip delayShow={500} />
      </div>
    );
  }

  return (
    <div className="form-group">
      {props.label && <label>{props.label}</label>}
      <input {...props} ref={ref} className={className + " " + props.className} />
    </div>
  );
}
